import { Permission } from "@/enums/permission";

export const permissionsInfo = {
  computed: {
    canViewFacilitiesData() {
      return this.$hasAccess(Permission.VIEW_FACILITIES_DATA);
    },
    canViewCompanyData() {
      return this.$hasAccess(Permission.VIEW_COMPANY_DATA);
    },
    canManageCompanyData() {
      return this.$hasAccess(Permission.MANAGE_COMPANY_DATA);
    },
    canViewDashboard() {
      return this.$hasAccess(Permission.VIEW_DASHBOARD);
    },
    canEditFacilityName() {
      return this.$hasAccess(Permission.EDIT_FACILITY_NAME);
    },
    canEditFacilityAddress() {
      return this.$hasAccess(Permission.EDIT_FACILITY_ADDRESS);
    },
    canEditFacilityLabels() {
      return this.$hasAccess(Permission.EDIT_FACILITY_LABELS);
    },
    canEditFacilityHours() {
      return this.$hasAccess(Permission.EDIT_FACILITY_HOURS);
    },
    canEditFacilityDescription() {
      return this.$hasAccess(Permission.EDIT_FACILITY_DESCRIPTION);
    },
    canEditFacilityOpeningDate() {
      return this.$hasAccess(Permission.EDIT_FACILITY_OPENING_DATE);
    },
    canEditFacilityOpenStatus() {
      return this.$hasAccess(Permission.EDIT_FACILITY_OPEN_STATUS);
    },
    canEditFacilityAttributes() {
      return this.$hasAccess(Permission.EDIT_FACILITY_ATTRIBUTES);
    },
    canEditFacilityWebsite() {
      return this.$hasAccess(Permission.EDIT_FACILITY_WEBSITE);
    },
    canEditFacilityPhoneNumber() {
      return this.$hasAccess(Permission.EDIT_FACILITY_PHONE_NUMBER);
    },
    canEditFacilityPrimaryCategory() {
      return this.$hasAccess(Permission.EDIT_FACILITY_PRIMARY_CATEGORY);
    },
    canEditFacilityAdditionalCategories() {
      return this.$hasAccess(Permission.EDIT_FACILITY_ADDITIONAL_CATEGORIES);
    },
    canEditFacilityStoreCode() {
      return this.$hasAccess(Permission.EDIT_FACILITY_STORE_CODE);
    },
    canEditFacilityServices() {
      return this.$hasAccess(Permission.EDIT_FACILITY_SERVICE_ITEMS);
    },
    canViewExternalChanges() {
      return this.$hasAccess(Permission.VIEW_EXTERNAL_CHANGES);
    },
    canApproveAndRejectExternalChanges() {
      return this.$hasAccess(Permission.APPROVE_AND_REJECT_EXTERNAL_CHANGES);
    },
    canViewExternalChangesHistory() {
      return this.$hasAccess(Permission.VIEW_EXTERNAL_CHANGES_HISTORY);
    },
    canProtectFromExternalChanges() {
      return this.$hasAccess(Permission.PROTECT_FROM_EXTERNAL_CHANGES);
    },
    canAddAndDeleteLocalPosts() {
      return this.$hasAccess(Permission.ADD_AND_DELETE_LOCAL_POSTS);
    },
    canViewLocalPosts() {
      return this.$hasAccess(Permission.VIEW_LOCAL_POSTS);
    },
    canViewPhotos() {
      return this.$hasAccess(Permission.VIEW_PHOTOS);
    },
    canAddAndDeletePhotos() {
      return this.$hasAccess(Permission.ADD_AND_DELETE_PHOTOS);
    },
    canViewAndReportCustomerMedia() {
      return this.$hasAccess(Permission.VIEW_AND_REPORT_CUSTOMER_MEDIA);
    },
    canAssessCustomerMedia() {
      return this.$hasAccess(Permission.ASSESS_CUSTOMER_MEDIA);
    },
    canViewReviewsAnalytics() {
      return this.$hasAccess(Permission.VIEW_REVIEWS_ANALYTICS);
    },
    canViewReviews() {
      return this.$hasAccess(Permission.VIEW_REVIEWS);
    },
    canReplyReviews() {
      return this.$hasAccess(Permission.REPLY_REVIEWS);
    },
    canViewGmbInsights() {
      return this.$hasAccess(Permission.VIEW_GMB_INSIGHTS);
    },
    canViewMapsRankings() {
      return this.$hasAccess(Permission.VIEW_MAPS_RANKINGS);
    },
    canViewMapsCompetitionRankings() {
      return this.$hasAccess(Permission.VIEW_MAPS_COMPETITION_RANKINGS);
    },
    canManageCompetitionPlaces() {
      return this.$hasAccess(Permission.MANAGE_COMPETITION_PLACES);
    },
    canManageKeywords() {
      return this.$hasAccess(Permission.MANAGE_KEYWORDS);
    },
    canManageGmbAccount() {
      return this.$hasAccess(Permission.MANAGE_GMB_ACCOUNT);
    },
    canManageExternalGmbAddresses() {
      return this.$hasAccess(Permission.MANAGE_EXTERNAL_GMB_ADDRESSES);
    },
    canViewTeam() {
      return this.$hasAccess(Permission.VIEW_TEAM);
    },
    canManageTeam() {
      return this.$hasAccess(Permission.MANAGE_TEAM);
    },
    canManageTags() {
      return this.$hasAccess(Permission.MANAGE_REVIEWS_CATEGORIES);
    },
    canTagReviews() {
      return this.$hasAccess(Permission.ASSIGN_REVIEWS_CATEGORIES);
    },
    canManageStoreLocator() {
      return this.$hasAccess(Permission.MANAGE_STORE_LOCATOR);
    },
    canConfigureAiReviewReply() {
      return this.$hasAccess(Permission.CONFIGURE_AI_REVIEW_REPLY);
    },
    canConfigureAiMediaAssessment() {
      return this.$hasAccess(Permission.CONFIGURE_AI_MEDIA_ASSESSMENT);
    },
    canViewQa() {
      return this.$hasAccess(Permission.VIEW_Q_AND_A);
    },
    canAddAndEditQa() {
      return this.$hasAccess(Permission.ADD_AND_EDIT_Q_AND_A);
    },
    canDeleteQa() {
      return this.$hasAccess(Permission.DELETE_Q_AND_A);
    }
  }
};
